import { getAPI } from 'requests/api';

interface OrdersReportInputs {
  by_status?: string;
  by_order_number?: string;
  by_user_name?: string;
  by_user_email?: string;
  by_product_name?: string;
  by_coupon_code?: string;
  by_cpf?: string;
  by_phone?: string;
  by_range_date?: string[];
  from_agent?: boolean | string;
}

export const createOrdersReport = async (
  inputs: OrdersReportInputs
): Promise<{ id: string }> => {
  const response = await getAPI().post('/admin/reports', {
    kind: 'sales_orders',
    inputs
  });

  return { id: response.data.id };
};
